import { environment } from '../environments/environment';
import { Currency } from '@df/interfaces';

// файл environment подменяется при использовании флага --configuration при запуске.
// см packege.json и angular.json, измененные в этом же коммите
export const MAIN_DOMAIN = environment.mainDomain;
// export const MAIN_DOMAIN = 'http://localhost:8000';

export const APP_PATH = {
    home: '',
    teacher: {
        main: 'teacher',
        prepare: '/teacher/prepare',
        teach: '/teacher/teach',
        analysis: '/teacher/analysis',
        accounts: '/teacher/accounts'
    },
    student: {
        main: 'student',
        class_list: 'class_list/'
    },
    profile: {
        main: 'profile',
        settings: {
            main: '/profile/settings',
            profile: '/profile/settings/profile'
        },
        awards: '/profile/awards',
        purchases: '/profile/purchases',
        notifications: '/profile/notifications'
    },
    results: {
        main: 'results',
        awards: 'awards'
    },
    reports: {
        main: 'reports'
    },
    login: 'login',
    registration: 'registration',
    notFound: 'not-found'
};

export const API_PATH = {
    user: 'accounts/user',
    login: 'accounts/login/',
    logout: 'accounts/logout',
    signup: 'accounts/signup',
    accounts: {
        current_currency: 'accounts/current_currency',
        lesson_currency: 'accounts/lesson_currency',
        reset_password: 'accounts/reset_password/'
    },
    app_configs: {
        update_notifications_config: 'app_user_configs/update_notifications_config',
        current_notifications_config: 'app_user_configs/current_notifications_config'
    },
    admin: {
        login: 'people/admin/login'
    },
    main: {
        schools: 'main/boxes_schools/'
    },
    people: {
        profile: 'people/profile',
        change_email: 'people/change_email',
        groups: 'people/groups/',
        patch_profile: 'people/groups/patch_profile',
        patch_profile_avatar: 'people/groups/patch_profile_avatar',
        classes: 'people/student/class/',
        current_user_classes: 'people/current_user_classes/',
        current_group_instance: 'people/current_group_instance',
        update_password: 'people/update_password',
        current_student: 'people/current_student',
        user_photo: 'people/user_photo',
        parent_children: 'people/parent_children',
        profile_schools: 'people/profile_schools'
    },
    achievements: {
        award_events: 'achievements/award_events/',
        standart_cards: 'achievements/standart_cards/',
        named_cards: 'achievements/named_cards/',
        certificates: 'achievements/certificates/',
        awards: 'achievements/awards/',
        add_students_awards: 'achievements/add_students_awards/',
        user_awards: 'achievements/user_awards/',
        event_award_cards: 'achievements/event_award_cards/',
        duplicate_card_awards: 'achievements/duplicate_card_awards/',
        update_used_privileges: 'achievements/update_used_privileges'
    },
    market: {
        user_purchases: 'market/user_purchases/',
        user_purchase: 'market/user_purchase/',
        duplicate_products: 'market/duplicate_products/',
        summary_deal_products: 'market/summary_deal_products/',
        medium_price: 'market/medium_price/'
    },
    main_analytics: {
        student_lesson_data: 'main_analytics/student_lesson_data/',
        student_simple_lessons_info: 'main_analytics/student_simple_lessons_info/',
        student_lesson_cards_results: 'main_analytics/student_lesson_cards_results/',
        create_reports_csv_data: 'main_analytics/create_reports_csv_data'
    },
    lessons: {
        lesson_for_student: 'lessons/lesson_for_student'
    },
    privileges: {
        epoch: 'privileges/epoch/',
        epoch_characters: 'privileges/epoch_characters'
    },
    notifications: {
        main: 'notifications/',
        simple_notifications: {
            first_parent_notification: 'notifications/simple_notifications/first_parent_notification'
        },
        check_current_user_notifications: 'notifications/check_current_user_notifications',
        current_user_notifications: 'notifications/current_user_notifications/',
        subscribe_app_event: 'notifications/subscribe_app_event/',
        check_subscribe_app_event: 'notifications/check_subscribe_app_event/',
        without_notification: 'notifications/without_notification/'
    },
    tournaments: {
        class_tournaments: 'tournaments/class_tournaments'
    }
};

export const INCREASE_OPERATION = 'increase';
export const DECREASE_OPERATION = 'decrease';
export const RESET_OPERATION = 'reset';
export const COMMENTS = {
    BUY: 'Покупка варианта',
    BUY_WITH_CASH: 'Покупка варианта за наличные',
    REWARD: 'Вознаграждение',
    REWARD_WITH_CASH: 'Вознаграждение наличными',
    PENALTY: 'Штраф',
    CASH_IN: 'Внесено на счет',
    CASH_OUT: 'Списано со счета',
    CASH_RESET: 'Снято все',
    CASH_IN_MALE: 'внес на счет',
    CASH_OUT_MALE: 'списал со счета',
    CASH_RESET_MALE: 'снял все',
    CASH_IN_FEMALE: 'внесла на счет',
    CASH_OUT_FEMALE: 'списала со счета',
    CASH_RESET_FEMALE: 'сняла все',
    EX_EXERCISE_REWARD: 'Вознаграждение за доп. задание'
};

export const REWARD_BANK_TYPES = {
    DRAHMA: 'drahma',
    STARS: 'stars',
    COINS: 'coins',
    KAIROS: 'kairos'
};

export const LESSON_CREATED = 0; // Готово
export const LESSON_IN_WORK = 1; // В работе
export const LESSON_COMPLETED = 2; // Завершенно
export const LESSON_CANCELED = 3; // Не проведенно
export const LESSON_COMPLETED_NOT_FINAL = 5; // Приостановленно

export const EXERCISE_TASK = 'task';
export const EXERCISE_LOGIC = 'logic';
export const EXERCISE_CALCULATION = 'calculation';
export const EXERCISE_PUZZLE_EXAMPLE = 'puzzle_example';
export const EXERCISE_PUZZLE_TASK = 'puzzle_task';
export const EXERCISE_MAGIC_BOX = 'magic';
export const EXERCISE_SEQUENCE = 'sequence';
export const EXERCISE_INSERT = 'insert';

export const DELETE_ACTION = 'delete';
export const COPY_ACTION = 'copy';

export const GENDER = {
    MALE: 'm',
    FEMALE: 'f'
};

export const AWARD_CARD_TYPES = {
    STANDART_CARD: 'Наградная карточка',
    NAMED_CARD: 'Именная карточка',
    CERTIFICATE: 'Граммота'
};

export const PLUS_SYM_KEY_CODE = 43;
export const MINUS_SYM_KEY_CODE = 45;
export const E_SYM_KEY_CODE = 101;
export const MINUTES_IN_ONE_DAY = 1440;
export const ENTER_KEY_CODE = 13;

export const FINISH_LESSON_TIME_SECONDS_FOR_STUDENT = 120;
export const FINISH_LESSON_TIME_SECONDS_FOR_TEACHER = 60;

export const TIMER_FOR_GET_HABIRINT_DATA = 5000;

export const KAIROS = <Currency>{
    id: 0,
    title: 'Кайрос',
    rate: 1,
    name_in_accusative: 'Кайроса',
    plural_name_less_5: 'Кайросы',
    plural_name_more_5: 'Кайросов',
    epoch: 0
};

export enum GROUPS {
    TEACHER = 'Учитель',
    STUDENT = 'Студент',
    PARENT = 'Родитель',
    TEACHER_HELPER = 'Помощник учителя',
    NAVIGATOR = 'Навигатор',
    NAVIGATOR_JUNIOR = 'Навигатор стажер',
    METODIST = 'Методист',
    SUPER_NAVIGATOR = 'Супер-навигатор'
}

export const EXTRA_EXERCISE = {
    NOT_SOLVED: 'not solved',
    SOLVED_CORRECT: 'solved correct',
    SOLVED_INCORRECT: 'solved incorrect'
};

export const TYPE_TRANSACTION = {
    TRANSACTION_TYPE_CASH: 'cash_reward',
    TRANSACTION_TYPE_BANK: 'bank_reward'
};

export enum EXERCISE_TYPES {
    EXERCISE_TASK = 'task',
    EXERCISE_LOGIC = 'logic',
    EXERCISE_CALCULATION = 'calculation',
    EXERCISE_PUZZLE_TASK = 'puzzle_task',
    EXERCISE_PUZZLE_EXAMPLE = 'puzzle_example',
    EXERCISE_MAGIC_BOX = 'magic',
    EXERCISE_SEQUENCE = 'sequence',
    EXERCISE_INSERT = 'insert',
    EXERCISE_ALL = 'all'
}

export const KATEX_FORMAT = 'Katex';

export const DEFAULT_ACCESS_RIGHTS = {
    view_other_lesson: {
        index_title: 1,
        is_access: false
    },
    create_lesson: {
        index_title: 5,
        is_access: false
    },
    edit_other_lesson: {
        index_title: 3,
        is_access: false
    },
    change_status_other_lesson: {
        index_title: 6,
        is_access: false
    },
    copy_other_lesson: {
        index_title: 4,
        is_access: false
    },
    delete_other_lesson: {
        index_title: 2,
        is_access: false
    },
    edit_templates: {
        index_title: 7,
        is_access: false
    },
    copy_templates: {
        index_title: 14,
        is_access: false
    },
    delete_templates: {
        index_title: 15,
        is_access: false
    },
    access_for_reports: {
        index_title: 19,
        is_access: false
    }
};


export const closeIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
  <defs>
    <style>.cls-1{fill:#465561;}.cls-2{fill:none;}</style>
  </defs>
  <g>
    <g>
      <rect class="cls-1" x="4" y="4" width="1" height="1"/>
      <rect class="cls-1" x="3" y="3" width="1" height="1"/>
      <rect class="cls-1" x="5" y="5" width="1" height="1"/>
      <rect class="cls-1" x="6" y="6" width="1" height="1"/>
      <rect class="cls-1" x="7" y="7" width="1" height="1"/>
      <rect class="cls-1" x="7" y="7" width="1" height="1"/>
      <rect class="cls-1" x="8" y="8" width="1" height="1"/>
      <rect class="cls-1" x="9" y="9" width="1" height="1"/>
      <rect class="cls-1" x="10" y="10" width="1" height="1"/>
      <rect class="cls-1" x="11" y="11" width="1" height="1"/>
      <rect class="cls-1" x="12" y="12" width="1" height="1"/>
      <rect class="cls-1" x="4" y="11" width="1" height="1" transform="translate(-7 16) rotate(-90)"/>
      <rect class="cls-1" x="3" y="12" width="1" height="1" transform="translate(-9 16) rotate(-90)"/>
      <rect class="cls-1" x="5" y="10" width="1" height="1" transform="translate(-5 16) rotate(-90)"/>
      <rect class="cls-1" x="6" y="9" width="1" height="1" transform="translate(-3 16) rotate(-90)"/>
      <rect class="cls-1" x="7" y="8" width="1" height="1" transform="translate(-1 16) rotate(-90)"/>
      <rect class="cls-1" x="7" y="8" width="1" height="1" transform="translate(-1 16) rotate(-90)"/>
      <rect class="cls-1" x="8" y="7" width="1" height="1" transform="translate(1 16) rotate(-90)"/>
      <rect class="cls-1" x="9" y="6" width="1" height="1" transform="translate(3 16) rotate(-90)"/>
      <rect class="cls-1" x="10" y="5" width="1" height="1" transform="translate(5 16) rotate(-90)"/>
      <rect class="cls-1" x="11" y="4" width="1" height="1" transform="translate(7 16) rotate(-90)"/>
      <rect class="cls-1" x="12" y="3" width="1" height="1" transform="translate(9 16) rotate(-90)"/>
      <rect class="cls-2" width="16" height="16"/>
    </g>
  </g>
</svg>
`

export const crossIcon = `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 18.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
     viewBox="0 0 11.3 11.3" enable-background="new 0 0 11.3 11.3" xml:space="preserve">
<polygon fill="#495660" points="10.9,0 0,10.9 0.5,11.3 11.3,0.5 11.3,0.5 "/>
  <polygon fill="#495660" points="0.5,0 0,0.5 10.9,11.3 11.3,10.9 11.3,10.9 "/>
</svg>
`

export const removeIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.3 13.9">
  <g>
    <path d="M11.5,12.7C11.5,12.7,11.5,12.7,11.5,12.7l-8.6,0c0,0,0,0,0,0V4.1H1.7v8.6c0,0.7,0.5,1.2,1.2,1.2h8.6
		c0.7,0,1.2-0.5,1.2-1.2V4.1h-1.2V12.7z"/>
    <rect x="4.9" y="7.5" width="4.5" height="0.8"/>
    <path d="M13.7,1.9H9.9V0.9C9.9,0.4,9.6,0,9.1,0H5.3C4.8,0,4.4,0.4,4.4,0.9v1.1H0.6C0.3,1.9,0,2.2,0,2.5
		c0,0.3,0.3,0.6,0.6,0.6h13.2c0.3,0,0.6-0.3,0.6-0.6C14.3,2.2,14.1,1.9,13.7,1.9 M5.4,1h3.5v0.9H5.4V1z"/>
  </g>
</svg>`;


export const copyIcon = `<svg xmlns="http://www.w3.org/2000/svg">
    <g>
        <path d="M2,11V4A2,2,0,0,1,4,2h7V3h1V1H4A3,3,0,0,0,1,4v8H3V11Z"/>
        <path d="M14,5v9H5V7A2,2,0,0,1,7,5h7m1-1H7A3,3,0,0,0,4,7v8H15V4Z"/>
        <rect x="7" y="9" width="5" height="1"/>
        <rect x="7" y="7" width="5" height="1"/>
        <rect x="7" y="11" width="5" height="1"/>
    </g>
</svg>
`

export const armIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
  <g>
    <path d="M10,8a4,4,0,1,1,6.62,3H18a5,5,0,1,0-8,0h1.36A4,4,0,0,1,10,8Z"/>
    <path d="M16,8a2,2,0,1,0-.28,1H14V8Z"/>
    <path d="M6,13l8-1v2L9,15v1h6l6-6,1,1-6,8H7L4,22,1.47,20.13a1.58,1.58,0,0,1-.18-2.38Z"/>
  </g>
</svg>`


export const checkboxUncheckedIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
  <defs>
    <style>.cls-1{fill:#ebe9ea;}.cls-2{fill:none;}</style>
  </defs>
  <g>
    <g>
      <path class="cls-1" d="M12,4v8H4V4h8m1-1H3V13H13V3Z"/>
      <rect class="cls-2" width="16" height="16"/>
    </g>
  </g>
</svg>
`

export const checkboxCheckedIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
  <defs>
    <style>.cls-1{fill:#ebe9ea;}.cls-2{fill:none;}.cls-3{fill:#8dceb3;}</style>
  </defs>
  <g>
    <g>
      <path class="cls-1" d="M12,8v4H4V4h6l1-1H3V13H13V7Z"/>
      <rect class="cls-2" width="16" height="16"/>
      <rect class="cls-3" x="9.29" y="3.46" width="1.41" height="7.07"
            transform="translate(12.12 19.02) rotate(-135)"/>
      <rect class="cls-3" x="6.29" y="5.88" width="1.41" height="4.24"
            transform="translate(-3.61 7.29) rotate(-45)"/>
    </g>
  </g>
</svg>`

export const printIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
  <defs>
    <style>.cls-1{fill:none;}.cls-2{fill:#465561;}</style>
  </defs>
  <g>
    <g>
      <rect class="cls-1" width="16" height="16"/>
      <path class="cls-2" d="M4,2h8V3h1V2a1,1,0,0,0-1-1H4A1,1,0,0,0,3,2V3H4Z"/>
      <path class="cls-2"
            d="M15,4H1V8a3,3,0,0,0,2,2.82V12a3,3,0,0,0,3,3h7V11h2ZM12,14H6a2,2,0,0,1-2-2V8h8Zm2-4H13V7H3V9.72A2,2,0,0,1,2,8V5H3V6H13V5h1Z"/>
      <rect class="cls-2" x="6" y="9" width="4" height="1"/>
      <rect class="cls-2" x="6" y="11" width="4" height="1"/>
      <rect class="cls-1" width="16" height="16"/>
    </g>
  </g>
</svg>
`

export const duplicateIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" viewBox="0 0 14.5 14.2">
  <g>
    <path d="M13.3,3.1H11V1.2C11,0.5,10.5,0,9.8,0H1.2C0.5,0,0,0.5,0,1.2v8.6C0,10.5,0.5,11,1.2,11h2.3v1.9
		c0,0.7,0.5,1.2,1.2,1.2h8.6c0.7,0,1.2-0.5,1.2-1.2V4.4C14.5,3.7,14,3.1,13.3,3.1 M1.2,9.9C1.2,9.9,1.2,9.8,1.2,9.9l0-8.6
		c0,0,0,0,0,0h8.6c0,0,0,0,0,0v1.9H4.7c-0.6,0-1.1,0.4-1.2,1c0,0.1,0,0.2,0,0.2v5.5H1.2z M13.3,12.9C13.3,13,13.3,13,13.3,12.9
		l-8.6,0c0,0,0,0,0,0V11V4.4c0,0,0,0,0,0h8.6c0,0,0,0,0,0V12.9z"/>
    <rect x="8.6" y="6" width="0.8" height="5.3"/>
    <rect x="6.4" y="8.2" width="5.3" height="0.8"/>
  </g>
</svg>
`

export const refreshIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
  <defs>
    <style>
      .refresh-cls-1,.refresh-cls-2{fill:none;}.refresh-cls-2{stroke:#465561;stroke-miterlimit:10;stroke-width:2px;}.refresh-cls-3{fill:#465561;}
    </style>
  </defs>
  <g>
    <g>
      <rect class="refresh-cls-1" width="24" height="24"/>
      <path class="refresh-cls-2" d="M4,12a8,8,0,1,1,8,8"/>
      <polygon class="refresh-cls-3" points="1 10.25 7 10.25 4 14.75 1 10.25"/>
    </g>
  </g>
</svg>
`

